module.exports = __webpack_public_path__ + "static/media/survey.2d03d441.png";